/*global RefLike*/
import { UnresolvedRefError, RefAlreadyResolvedError } from './errors';
export class Ref {
    constructor() {
        this._resolved = false;
    }
    get resolved() {
        return this.isResolved();
    }
    isResolved() {
        return this._resolved;
    }
    get $() {
        if (!this.isResolved()) {
            throw new UnresolvedRefError(this);
        }
        return this._$;
    }
    resolve(t) {
        if (this.isResolved()) {
            throw new RefAlreadyResolvedError(this);
        }
        this._$ = t;
        this._resolved = true;
    }
}
export function ref() {
    return new Ref();
}
//# sourceMappingURL=ref.js.map